import { Route, Routes, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useClientAthlete } from "../../../context/ClientAthleteContext";
import ChatInboxHub from "../common/ChatInboxHub";
import ChatConversationPage from "../common/ChatConversationPage";
import { initials } from "../common/ChatThread";

const CLIENT_CHAT_BASE = "/app/chat";

function ClientMemberChatRoute() {
  const { userId } = useParams();
  const location = useLocation();
  const name = location.state?.name || "Участник";

  return (
    <ChatConversationPage
      title={name}
      subtitle="Личные сообщения"
      backTo={CLIENT_CHAT_BASE}
      threadType="member"
      peerUserId={userId}
      mode="client"
      avatarLabel={initials(name)}
    />
  );
}

function ClientGroupChatRoute() {
  const { groupId } = useParams();
  const location = useLocation();
  const { athleteQueryParam } = useClientAthlete();
  const name = location.state?.name || "Группа";

  return (
    <ChatConversationPage
      title={name}
      subtitle="Чат тренировочной группы"
      backTo={CLIENT_CHAT_BASE}
      threadType="group"
      groupId={groupId}
      mode="client"
      athleteQueryParam={athleteQueryParam}
      avatarLabel="👥"
    />
  );
}

export default function ClientChatRoutes() {
  const { tenant } = useSelector((state) => state.auth);
  const { athleteQueryParam, activeAthlete, isParentMode } = useClientAthlete();

  const personalTitle =
    isParentMode && activeAthlete?.full_name
      ? activeAthlete.full_name
      : tenant?.name || "Клуб";

  return (
    <Routes>
      <Route index element={<ChatInboxHub portal="client" />} />
      <Route
        path="club"
        element={
          <ChatConversationPage
            title="Чат клуба"
            subtitle="Общий чат всех участников клуба"
            backTo={CLIENT_CHAT_BASE}
            threadType="club"
            mode="client"
            avatarLabel="🏟"
          />
        }
      />
      <Route
        path="personal"
        element={
          <ChatConversationPage
            title={personalTitle}
            subtitle="Тренер и администрация"
            backTo={CLIENT_CHAT_BASE}
            threadType="direct"
            mode="client"
            athleteQueryParam={athleteQueryParam}
            avatarLabel={initials(personalTitle)}
          />
        }
      />
      <Route path="member/:userId" element={<ClientMemberChatRoute />} />
      <Route path="group/:groupId" element={<ClientGroupChatRoute />} />
    </Routes>
  );
}
